// extracted by mini-css-extract-plugin
module.exports = {"actionsContainer":"style_actionsContainer__3qEJy","alignRightContainer":"style_alignRightContainer__335o_","spacer":"style_spacer__3SsUA"};